import { render } from "./ChooseSBPBank.vue?vue&type=template&id=671c1338&ts=true"
import script from "./ChooseSBPBank.vue?vue&type=script&lang=ts"
export * from "./ChooseSBPBank.vue?vue&type=script&lang=ts"

import "./ChooseSBPBank.vue?vue&type=style&index=0&id=671c1338&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__